import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from './../../shared/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup , Validators, FormControl} from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { UserService } from './../../@core/data/users.service';
import { Observable, Subject } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';

import * as _moment from 'moment';
import { Moment} from 'moment';

import {ViewChildren, QueryList} from '@angular/core';
import {MatAutocompleteTrigger} from '@angular/material/autocomplete';
import { ConfirmationService } from 'primeng/api';
import { loadavg } from 'os';
import { log } from 'util';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'educational',
  template: `<style>
  .mat-form-field--inline {
      display: flex;
      flex-direction: row;
      align-items: center;
  }

  .mat-form-field--inline .mat-form-field {
      display: inline-block;
      width: 100%;
      vertical-align: middle;
  }

  .mat-form-field--inline .mat-form-field:nth-child(1) {
      margin-right: 10px;
  }

  @media (max-width: 767px) {
      #selectLine {
          width: 65%; 
      }
  }

  @media (min-width: 1200px) {
      #selectLine {
          width: 145%;
      }
  }

  @media (min-width: 768px) {
      #selectLine {
          width: 65%;
      }

      .offset-md-3 {
          margin-left: 0%;
      }

      .col-md-6 {
          max-width: 100%;
      }

      #roll_no {
          left: 50px;
      }

      #semester_css {
          padding-left: 45px;
      }
  }

  @media (min-width: 992px) {
      #selectLine {
          width: 145%;
      }

      #roll_no {
          left: 50px;
      }

      #semester_css {
          padding-left: 45px;
      }
  }

  .example-full-width {
      width: 100%;
  }

  .popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Dimmed background */
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  z-index: 1000;
}

.popup {
  background: white;
  padding: 40px; /* Spacing around content */
  border-radius: 10px; /* Rounded corners */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4); /* Stronger shadow */
  text-align: center;
  width: 800px; /* Width of the popup */
}

h2 {
  font-size: 2.4rem; /* Title font size */
  margin-bottom: 20px;
  font-weight: bold;
}

.popup-message {
  font-size: 1.5rem; /* Message font size */
  color: red; /* Text color */
  font-weight: bold; /* Bold text */
  line-height: 2; /* Line height for readability */
  margin-bottom: 30px;
}

.popup-actions {
  margin-top: 30px;
}

.ok-button {
  background-color: #4caf50; /* Green background for OK */
  color: white;
  padding: 15px 30px; /* Button size */
  font-size: 1.2rem; /* Button text size */
  border: none;
  border-radius: 6px; /* Rounded corners */
  cursor: pointer;
}

.ok-button:hover {
  background-color: #45a049; /* Slightly darker green on hover */
}

</style>

<nb-card status="success" [style.height.px]="600">
<nb-card-header>Add Your Last Appeared Exam Details.</nb-card-header>
  <nb-card-header>तुमच्या शेवटच्या परीक्षेचे तपशील जोडा.</nb-card-header>
  <nb-card-body>
      <form [formGroup]="edu_form" class="step-container">

          <div class="row">
              <div class="col-xl-3">
                  Are you belongs to autonomus college:
              </div>
              <div class="col-xl-9">
                  <mat-form-field style="width:100% !important">
                      <mat-select [(ngModel)]="isAutonomusValue" name="isAutonomusValue" formControlName="isAutonomusCtrl"
                          (selectionChange)="getIsAutonomus($event)">
                          <mat-option [value]="'Yes'">Yes</mat-option>
                          <mat-option [value]="'No'">No</mat-option>
                      </mat-select>
                  </mat-form-field>
                  <span *ngIf="edu_form.controls.isAutonomusCtrl.invalid && edu_form.controls.isAutonomusCtrl.touched" style="color:red;">Please select an option.</span>
              </div>
          </div>

          <div class="row">
              <div class="col-xl-3">
                  Course Type:
              </div>
              <div class="col-xl-9">
                  <mat-form-field style="width:100% !important">
                      <mat-select [(ngModel)]="course_type" name="course_type" formControlName="course_typeCtrl"
                          (selectionChange)="getCourse_type($event)" [disabled]="fetched_data">
                          <mat-option [value]="'Regular'">Regular</mat-option>
                          <mat-option [value]="'External'">External</mat-option>
                      </mat-select>
                  </mat-form-field>
                  <br><span *ngIf="courseExternzl == true" style="color:red;"> External students don't need to upload
                      TC and
                      NOC</span>
              </div>
          </div>

          <div class="row">
              <div class="col-xl-3">College Name : </div>
              <div class="col-xl-9">
                  <div class="col-xl-12" *ngIf="collegenameshow == false">
                      <form class="example-form">
                          <mat-form-field class="example-full-width">
                              <input type="text" (focus)="onFocus(0)" placeholder="Select College" aria-label="Number"
                                  matInput [formControl]="myControl" [matAutocomplete]="auto" [disabled]="fetched_data">
                              <mat-autocomplete #auto="matAutocomplete">
                                  <mat-option
                                      (onSelectionChange)="selectCollegeBachelor($event, option.college_code,option.college_name)"
                                      *ngFor="let option of filteredOptions | async" [value]="option.college_name" [disabled]="fetched_data">
                                      {{option.college_name}}
                                  </mat-option>
                              </mat-autocomplete>
                          </mat-form-field>
                      </form>
                  </div>
                  <div class="row" *ngIf="collegenameshow == true">
                      <input formControlName="collegeNameCtrl" nbInput type="text" readonly class="form-control col-xl-11">
                      <a class="col-xl-1" >
                          <i title="Edit College Name" class="fas fa-pen-fancy" (click)="editCollegeName()"></i>
                      </a>
                  </div>
              </div>
          </div>

          <br>

          <div class="row">
              <div class="col-xl-3">Course Name : </div>
              <div class="col-xl-9">
                  <div class="col-xl-12" *ngIf="coursenameshow == false">
                      <form class="example-form">
                          <mat-form-field class="example-full-width">
                              <input type="text" (focus)="onFocus(1)" placeholder="Select Course Name"
                                  aria-label="Number" matInput [formControl]="myControlCourse"
                                  [matAutocomplete]="auto" [disabled]="fetched_data">
                              <mat-autocomplete #auto="matAutocomplete">
                                  <mat-option style="font-size:12px;" [disabled]="fetched_data"
                                      (onSelectionChange)="selectCourse($event, option.course_name,  option.duration)"
                                      *ngFor="let option of filteredOptionCourses | async"
                                      [value]="option.course_name" matTooltip={{option.course_name}}>
                                      {{option.course_name}}
                                  </mat-option>
                              </mat-autocomplete>
                          </mat-form-field>
                      </form>
                  </div>
                  <div *ngIf="coursenameshow == true" class="row">
                      <input formControlName="courseNameCtrl" nbInput type="text" class="form-control col-xl-11" readonly>
                      <a class="col-xl-1">
                          <i title="Edit Course Name" class="fas fa-pen-fancy " (click)="editCourseName()"></i>
                      </a>
                  </div>
              </div>
          </div>

          <br>

          <div class="row" *ngIf="showSpecialization">
              <div class="col-xl-3" id="specialization">Specialization : </div>
              <div class="col-xl-9">
                  <mat-form-field>
                      <mat-select formControlName="specialization" placeholder="Select Specialization"
                          [disabled]="fetched_data">
                          <mat-option *ngFor="let spec of specializationList" [value]="spec">{{spec}}</mat-option>
                      </mat-select>
                  </mat-form-field>
                  <span *ngIf="edu_form.controls.specialization.invalid && edu_form.controls.specialization.touched"
                      style="color: red;">Please Select Specialization</span>
              </div>
          </div>
          <!-- <div class="row">
           <div class="col-md-3">College Address : </div>
           <div class="col-md-9"> <input  ngModel="{{edu_data?.CollegeAddress}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.collegeAddressCtrl.invalid && (edu_form.controls.collegeAddressCtrl.dirty || edu_form.controls.collegeAddressCtrl.touched)}" formControlName="collegeAddressCtrl" placeholder="Address" id="" class="form-control" readonly> </div>
         </div>-->
          <br>
          <div class="row">
              <div class="col-xl-3">Examination Pattern type : </div>
              <div class="col-xl-9">
                  <mat-form-field>
                      <mat-select [(value)]="pattern" name="pattern" formControlName="collegePatternCtrl"
                          (selectionChange)="getData($event)" [disabled]="fetched_data">
                          <mat-option [value]="'semester'">Semester</mat-option>
                          <mat-option [value]="'annual'">Annual</mat-option>
                      </mat-select>
                  </mat-form-field>
                  <span *ngIf="ptternValidation===false" style="color:red;">Please select Pattern type</span>
              </div>
              <div class="col-xl-3" *ngIf="pattern=='annual'">
                  Last attended year: </div>
              <div class="col-xl-9" *ngIf="pattern=='annual'">
                  <mat-form-field>
                      <mat-select [(ngModel)]="pattern_year" (selectionChange)="onSelectPattern_year($event)"
                          formControlName="collegeYearPatternCtrl" [disabled]="fetched_data">
                          <mat-option *ngFor="let pattern_year of pattern_data_year"
                              [value]="pattern_year">{{pattern_year}}</mat-option>
                      </mat-select>
                  </mat-form-field>
                  <!--<span *ngIf="collegeYearValidation===false" style="color:red;">Please select College Year.</span>-->
              </div>
              <div class="col-xl-3" *ngIf="pattern=='semester'">
                  Last Attended Semester:
              </div>
              <div class="col-xl-9" *ngIf="pattern=='semester'">
                  <mat-form-field>
                      <mat-select [(ngModel)]="pattern_semester" (selectionChange)="onSelectPattern_sem($event)"
                          formControlName="collegeSemPatternCtrl" [disabled]="fetched_data">
                          <mat-option *ngFor="let pattern_semester of pattern_data_sem"
                              [value]="pattern_semester">{{pattern_semester}}</mat-option>
                      </mat-select>
                  </mat-form-field>
                  <span *ngIf="collegeYearValidation===false" style="color:red;">Please select College Year.</span>

              </div>
              <!-- <div class="col-md-9"> <input ngModel="{{edu_data?.PartName}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.partNameCtrl.invalid && (edu_form.controls.partNameCtrl.dirty || edu_form.controls.partNameCtrl.touched)}" formControlName="partNameCtrl" placeholder="Part Name" id="" class="form-control" readonly> </div> -->
          </div>
          <div class="row">
              <div class="col-xl-3">Passing Month & Year :</div>
              <div class="col-xl-9">
                  <mat-form-field appearance="fill">
                      <mat-label>Month and Year</mat-label>
                      <input matInput [matDatepicker]="dp" [formControl]="date" [max]="maxDate" (focus)="dp.open()"
                          readonly [disabled]="fetched_data">
                      <mat-datepicker-toggle matSuffix [for]="dp" (focus)="dp.open()"></mat-datepicker-toggle>
                      <mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYearHandler($event);onPassingYear($event)"
                          (monthSelected)="chosenMonthHandler($event, dp)" panelClass="example-month-picker">
                      </mat-datepicker>
                  </mat-form-field>
                  <span *ngIf="monthYearValidation===false" style="color:red;">Please select month and year.</span><br>
                  <div class="form-group col-md-12" *ngIf="yearValid">
                    <span style="font-weight: bold; color: red;">If you are a pass-out student from 2004 to 2019, You need to apply offline by visiting the University. (जर तुम्ही 2004 ते 2019 दरम्यान सोलापूर युनिव्हर्सिटीमधून पास आहात, तर तुम्हाला युनिव्हर्सिटीला जाऊन ऑफलाइन अर्ज करावा लागेल.)</span>
                  </div>
              </div>
              <div class="col-xl-3" id="roll_no" *ngIf="!fetched_data">Roll No/Seat No : </div>
              <div class="col-xl-9" *ngIf="!fetched_data">
                  <input   ngModel="{{edu_data?.rollNo}}" nbInput type="text" pattern="[A-Za-z0-9]{1,12}"
                      (keypress)="OnlyNoCharAllowed($event)" 
                      [ngClass]="{'form-control-danger': edu_form.controls.rollNoCtrl.invalid && (edu_form.controls.rollNoCtrl.dirty || edu_form.controls.rollNoCtrl.touched)}"
                      formControlName="rollNoCtrl" placeholder="Roll No" id="" class="form-control">
                  <span *ngIf=" edu_form.controls.rollNoCtrl.invalid && edu_form.controls.rollNoCtrl.touched" 
                      style="color: red;">Please Enter Valid Roll No/Seat No.</span>
              </div>
              <div class="col-xl-3" id="roll_no" *ngIf="fetched_data">Roll No/Seat No : </div>
              <div class="col-xl-9" *ngIf="fetched_data">
                  <input readonly  ngModel="{{edu_data?.rollNo}}" nbInput type="text" pattern="[A-Za-z0-9]{1,12}"
                      (keypress)="OnlyNoCharAllowed($event)" 
                      [ngClass]="{'form-control-danger': edu_form.controls.rollNoCtrl.invalid && (edu_form.controls.rollNoCtrl.dirty || edu_form.controls.rollNoCtrl.touched)}"
                      formControlName="rollNoCtrl" placeholder="Roll No" id="" class="form-control">
                  <span *ngIf=" edu_form.controls.rollNoCtrl.invalid && edu_form.controls.rollNoCtrl.touched" 
                      style="color: red;">Please Enter Valid Roll No/Seat No.</span>
              </div>
          </div>

          <div class="row">

              <div class="col-xl-3" *ngIf="fetched_data"> PRN Number :</div>
              <div class="col-xl-9" *ngIf="fetched_data">
                  <input readonly matInput ngModel="{{edu_data?.prn_no}}" formControlName="prn_no" pattern="[0-9]{6,16}"
                      [ngClass]="{'form-control-danger': edu_form.controls.prn_no.invalid && (edu_form.controls.prn_no.dirty || edu_form.controls.prn_no.touched )}"
                      class="form-control"  >
                  <br><span
                      *ngIf="edu_form.controls.prn_no.invalid && (edu_form.controls.prn_no.dirty || edu_form.controls.prn_no.touched )"
                      style="color: red;">Only 6-16 digit numbers are allowed.</span>
              </div>

              <div class="col-xl-3" *ngIf="!fetched_data"> PRN Number :</div>
              <div class="col-xl-9" *ngIf="!fetched_data">
                  <input matInput ngModel="{{edu_data?.prn_no}}" formControlName="prn_no" pattern="[0-9]{6,16}"
                      [ngClass]="{'form-control-danger': edu_form.controls.prn_no.invalid && (edu_form.controls.prn_no.dirty || edu_form.controls.prn_no.touched )}"
                      class="form-control"  >
                  <br><span
                      *ngIf="edu_form.controls.prn_no.invalid && (edu_form.controls.prn_no.dirty || edu_form.controls.prn_no.touched )"
                      style="color: red;">Only 6-16 digit numbers are allowed.</span>
              </div>


              <div class="col-xl-3">Result Status : </div>
              <div class="col-xl-9">
                  <mat-form-field>
                      <mat-select [(ngModel)]="result" name="result" formControlName="resultCtrl"
                          (selectionChange)="getResult($event)" [disabled]="fetched_data"> 
                          <mat-option [value]="'Pass'">Pass</mat-option>
                          <mat-option [value]="'Fail'">Fail</mat-option>
                          <mat-option [value]="'Absent'">Absent</mat-option>
                          <mat-option [value]="'Not Appeared'">Not Appeared</mat-option>
                          <mat-option [value]="'ATKT'">ATKT</mat-option>
                      </mat-select>
                  </mat-form-field>
                  <!--  <span *ngIf="resultValidation===false" style="color:red;">Please select Pattern type</span> -->
              </div>
          </div><br><br>

          

          <div class="row">
              <div>
                  <h4>तुम्ही ज्या विद्यापीठात प्रवेश घेऊ इच्छित आहात त्या विद्यापीठाचा तपशील (Details) इनपुट करा                  </h4>
              </div>
          </div><br>
          <marquee>
              <h5><u><b style="color:red; font-size: 100%;">विचारलेले तपशील (Details) योग्यरित्या इनपुट करा कारण ते तुमच्या स्थलांतर प्रमाणपत्रावर (Migration Certificate) छापले जाणार आहेत.</b></u></h5>
          </marquee><br>
          <div class="row">
              <div class="col-md-3"> Name of Other University : </div>
              <div class="col-md-6">
                  <input nbInput type="text" ngModel="{{edu_data?.otherUniversity}}"
                      formControlName="otherUniversityCtrl"
                      [ngClass]="{'form-control-danger': edu_form.controls.otherUniversityCtrl.invalid && (edu_form.controls.otherUniversityCtrl.dirty || edu_form.controls.otherUniversityCtrl.touched)}"
                      placeholder="Other University" class="form-control" [disabled]="fetched_data">
                  <br><span
                      *ngIf="edu_form.controls.otherUniversityCtrl.invalid && edu_form.controls.otherUniversityCtrl.touched"
                      style="color: red;">Please enter the name of university.</span>
              </div>
          </div>
          <div class="row">
              <div class="col-md-3">Either</div>
          </div>
          <br>
          <div class="row">
              <div class="col-md-3"> Name of Other College: </div>
              <div class="col-md-6">
                  <input nbInput type="text" ngModel="{{edu_data?.otherCollege}}" formControlName="otherCollegeCtrl"
                      [ngClass]="{'form-control-danger': edu_form.controls.otherCollegeCtrl.invalid && (edu_form.controls.otherCollegeCtrl.dirty || edu_form.controls.otherCollegeCtrl.touched)}"
                      placeholder="Other College" class="form-control" [disabled]="fetched_data">
                  <br><span *ngIf="uniValidation == false" style="color: red;">Please enter Either name of College or
                      University.</span>
              </div>
          </div><br>
          <div class="row">
              <div class="col-md-3"> Course Name: </div>
              <div class="col-md-6">
                  <input nbInput type="text" ngModel="{{edu_data?.otherCourse}}" formControlName="otherCourseCtrl"
                      [ngClass]="{'form-control-danger': edu_form.controls.otherCourseCtrl.invalid && (edu_form.controls.otherCourseCtrl.dirty || edu_form.controls.otherCourseCtrl.touched)}"
                      placeholder="Course Name" class="form-control" [disabled]="fetched_data">
                  <br><span
                      *ngIf="edu_form.controls.otherCourseCtrl.invalid && edu_form.controls.otherCourseCtrl.touched "
                      style="color: red;">Please enter Course Name.</span>
              </div>
          </div>
      </form>
  </nb-card-body>
  <nb-card-footer>
      <div class="row">
          <div class="col-md-3" style="text-align: center;margin-bottom: 2%;">
              <button nbButton hero status="primary" (click)="dismiss()">Close</button>
          </div>
          <div class="col-md-3" style="text-align: center;">
              <button *ngIf="amount_paid == 'false' && !yearValid" nbButton status="info" (click)="saveEdu()">save</button>
          </div>
      </div>

  </nb-card-footer>
</nb-card>
<div class="popup-overlay" *ngIf="showPopup">
  <div class="popup">
    <h2>Confirmation</h2>
    <p class="popup-message">
      If you are a pass-out student from 2004 to 2019, You need to apply offline by visiting the University.
      <br />
      <strong>
        (जर तुम्ही 2004 ते 2019 दरम्यान सोलापूर युनिव्हर्सिटीमधून पास आहात, तर तुम्हाला युनिव्हर्सिटीला जाऊन ऑफलाइन अर्ज करावा लागेल.)
      </strong>
    </p>
    <div class="popup-actions">
      <button class="ok-button" (click)="onConfirm()">OK</button>
    </div>
  </div>
</div>
<div class="popup-overlay" *ngIf="isAutonomus">
  <div class="popup">
    <h2>Confirmation</h2>
    <p class="popup-message">
      Students from autonomous colleges are not eligible to apply here.
    </p>
    <div class="popup-actions">
      <button class="ok-button" (click)="onConfirm()">OK</button>
    </div>
  </div>
</div>
<p-confirmDialog [style]="{width: '425px'}"></p-confirmDialog>`,
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class EducationalFormComponent implements OnInit {
  @ViewChildren(MatAutocompleteTrigger) autoComplete: QueryList<MatAutocompleteTrigger>;
  FeedbackForm : FormGroup;
  @Input() collegeAddress: any;
  @Input() collegeName: any;
  @Input() user_id: any;
  @Input() edu_id: any;
  @Input() source: any;
  @Input() course: any;
  @Input() prnNumber: any;
 
  //@Input() course_name:string;
  @Input() amount_paid:string;
  @Input() admin_show:string;
  validations_flag = false;
  feedback_message ;
  showExperience = false;

  edu_form: FormGroup;
  filteredOptions: Observable<string[]>;
  filteredOptionCourses: Observable<string[]>;
  myControl = new FormControl('',Validators.required);
  myControlCourse = new FormControl('',Validators.required);
  years_array;
  courseValidation = true;
  collegeValidation = true;
  collegeYearValidation = true;
  uniValidation  = true;
  monthValidation  = true;
  yearValidation = true;
  rollNOValidation = true;
  monthYearValidation = true;
  yearValid: boolean = false;
  showPopup: boolean = false;
  edu_data;
  course_data = [];
  college_data = [];
  user: any;
  collegenameshow = false;
  coursenameshow = false;
  collegename;
  pattern_data_year = ['First', 'Second', 'Third', 'Fourth', 'Fifth','Sixth'];
  pattern_data_sem = ['Semester I', 'Semester II', 'Semester III', 'Semester IV', 'Semester V', 'Semester VI', 'Semester VII', 'Semester VIII', 'Semester IX', 'Semester X', 'Semester XI', 'Semester XII'];
  date = new FormControl(moment());
  maxDate = new Date();
  
  readonly numberpattern = /^[-+]?[0-9]+$/ ;
  readonly letterpattern =/^[A-Za-z]+$/;
  showPattern: boolean;
  pattern: any;
  patternData: any;
  college_name: any;
  pattern_data = [];
  pattern_annual: boolean;
  pattern_year: any;
  college: any;
  showButton: any;
  errorPopup: boolean;
  pattern_semester: any;
 
  academicYear: any;
  ptternValidation: boolean;
  result: any;
  pop_sem: any;
  pop_year: any;
  duration: any;
  degree_type: any;
  stillStudying: boolean = false;
  fetched_data : boolean = false;
  course_type: any;
  college_code: any;
  prn_no: any;
  courseExternzl: boolean;
  courseData: any[] = [];
  specializationList: string[] = [];
  showSpecialization = false;
  savedSpecialization = null;
  collegeData : any[] = [];
  collegeId: any;
  collegeCourse : any[] = [];
  selectedCollege: string;
  courseId: any;
  selectedcourse : string;
  isAutonomus: boolean = false;
  isAutonomusValue: any;

  constructor(protected api : ApiService,
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    protected ref: NbDialogRef<EducationalFormComponent>) { }

  async ngOnInit() {

    this.edu_form = this.formBuilder.group({
      collegeNameCtrl : [ '' ,  Validators.required],
      // collegeAddressCtrl : [ '' ],
      collegePatternCtrl : [''],
      courseNameCtrl: [ '',Validators.required ],
      collegeYearPatternCtrl : [''],
      collegeSemPatternCtrl : [''],
      // partNameCtrl : [ '' ],
      // semesterCtrl : [ '' ],
      monthYearCtrl : [ '' ,  Validators.required],
      //monthCtrl : [ '' ,  Validators.required],
      //yearCtrl : [ '' ,  Validators.required],
      rollNoCtrl : [ '' ,  Validators.required],
      resultCtrl : ['',Validators.required],
      //overAllGradeCtrl : [ '' ,  Validators.required],
      otherUniversityCtrl :[''],
      otherCollegeCtrl :[''],
      otherCourseCtrl :[''],
      course_typeCtrl :['',Validators.required],
      isAutonomusCtrl :['',Validators.required],
      prn_no :['',[Validators.minLength(6),Validators.maxLength(16),Validators.required]],
      specialization : ['']
    })

    // if(this.course_name!=''){
    //   this.coursenameshow = true;
    //   this.edu_form.patchValue({
    //     courseNameCtrl : this.course_name,
    //   })
    // }


    
    this.api.getColleges()
      .subscribe(
        (data: any) => { 
          if(data['status'] == 200){
          this.collegeData = data['data']
            // data['colleges'].forEach((element)=>{
            //   this.college_data.push( element ) 
            // })
          }else{

          }
    });

    this.api.getCourses()
    .subscribe(
      (data: any) => { 
        if(data['status'] == 200){
          this.courseData = data['data']
          // A course may already be set (editing an existing entry) — show its list now.
          this.syncSpecializationForCourse(this.edu_form.controls.courseNameCtrl.value);
          // this.course_data = [];
          // data['data'].forEach((element)=>{
          //   this.course_data.push( element ) 
          // })
        }else{

        }
    });

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
    
    this.filteredOptionCourses = this.myControlCourse.valueChanges.pipe(
      startWith(''),
      map(value => this._filterCourse(value))
    );


    const now = new Date().getUTCFullYear();    
    this.years_array = Array(now - (now - 50)).fill('').map((v, idx) => now - idx);
    if(this.user_id != null){
      this.api.getEducation(this.edu_id,this.user_id)
      .subscribe(
        (data: any) => { 
          if(data['status'] == 200){
            this.edu_data = data['data'];
            this.result = this.edu_data.result;
            this.date = new FormControl(moment(this.edu_data.Month));
            this.edu_form.patchValue({
              monthYearCtrl :this.date.value,
            })
           this.fetched_data = data['data']['fetched_data'];
           this.onPassingYear(this.edu_data.Year);
            // Autonomous students are now allowed to apply — blocking condition disabled.
            // this.isAutonomus = this.edu_data.CollegeName.includes('Autonomus') ? true : false;
           if(this.edu_data.Month){
            this.date = new FormControl(moment(this.edu_data.Month));
           }
            this.course_type = data['data']['course_type'];
            this.isAutonomusValue = data['data']['isAutonomus'] == 1 ? 'Yes' : 'No';
            this.edu_form.patchValue({
              isAutonomusCtrl : this.isAutonomusValue,
            })
            this.edu_form.patchValue({
              monthYearCtrl :this.date.value,
            })
            if(data['data']['CollegeName']){
              this.edu_form.controls.collegeNameCtrl.setValidators([]);
              this.edu_form.controls.collegeNameCtrl.updateValueAndValidity();
              this.collegenameshow = true;
              this.edu_form.patchValue({
                collegeNameCtrl :data['data']['CollegeName'],
              })
            }
            if(data['data']['CourseName']){
              this.edu_form.controls.courseNameCtrl.setValidators([]);
              this.edu_form.controls.courseNameCtrl.updateValueAndValidity();
              this.coursenameshow = true;
              this.edu_form.patchValue({
                courseNameCtrl :data['data']['CourseName'],
              })
              this.savedSpecialization = this.edu_data.specialization ? this.edu_data.specialization : null;
              this.edu_form.patchValue({
                specialization : this.savedSpecialization,
              })
              this.syncSpecializationForCourse(data['data']['CourseName']);
            }
            if(data['data']['pattern']){
              this.edu_form.controls.collegePatternCtrl.setValidators([]);
              this.edu_form.controls.collegePatternCtrl.updateValueAndValidity();
              this.pattern = data['data']['pattern']
            }
            if(data['data']['duration']){
            this.duration = data['data']['duration'];
            var duration_year = this.duration;
            var duratio_sem = 2*this.duration;
            this.pattern_data_year = this.pattern_data_year.splice(0,duration_year);
            this.pattern_data_sem = this.pattern_data_sem.splice(0,duratio_sem);
            }
            
            if(data['data']['Semester']){
              this.edu_form.controls.collegeSemPatternCtrl.setValidators([]);
              this.edu_form.controls.collegeSemPatternCtrl.updateValueAndValidity();
              this.pattern_semester = data['data']['Semester'];console.log("this.paternsemester",this.pattern_semester);
              // this.pop_sem=this.pattern_data_sem.slice(-1);            
            }
            if(data['data']['CollegeYear']){
              this.edu_form.controls.collegeYearPatternCtrl.setValidators([]);
              this.edu_form.controls.collegeYearPatternCtrl.updateValueAndValidity();
              this.pattern_year = data['data']['CollegeYear'];console.log("this.paternsYear",this.pattern_year);
              // this.pop_year=this.pattern_data_year.slice(-1); 
            }
            
          }else{
            this.fetched_data = false;
          }
      });
    }
  }

  private _filter(value: string){
    const filterValue = this._normalizeValue(value);
    let sourceList = this.collegeData;
    if(this.isAutonomusValue === 'Yes'){
      // only autonomous colleges
      sourceList = this.collegeData.filter(option => option.college_name && option.college_name.includes('Autonomous'));
    }else if(this.isAutonomusValue === 'No'){
      // hide autonomous colleges
      sourceList = this.collegeData.filter(option => !(option.college_name && option.college_name.includes('Autonomous')));
    }
    return sourceList.filter(option => this._normalizeValue(option.college_name).includes(filterValue));
  }

  private _filterCourse(value: string){
    const filterValue = this._normalizeValue(value);
    return this.courseData.filter(option => this._normalizeValue(option.course_name).includes(filterValue)); 
    
  }
  
  private _normalizeValue(value: string): string {
    if(value){
      return value.toLowerCase().replace(/\s/g, '');
    }else{
      return '';
    }
  }

  saveEdu() {
    this.courseValidation = true;
    this.collegeYearValidation = true;
    this.uniValidation = true;
    this.monthValidation = true;
    this.yearValidation = true;
    this.rollNOValidation = true;
    this.monthYearValidation = true;
    this.ptternValidation = true;
    var error=this.findInvalidControls(this.edu_form.controls);
    console.log("error---->"+error);

    console.log("this.edu_form.valid---->"+this.edu_form.valid);
    if((this.edu_form.controls.otherCollegeCtrl.value === null || this.edu_form.controls.otherCollegeCtrl.value ==='' || this.edu_form.controls.otherCollegeCtrl.value ===undefined) && (this.edu_form.controls.otherUniversityCtrl.value === null || this.edu_form.controls.otherUniversityCtrl.value ==='' || this.edu_form.controls.otherUniversityCtrl.value ===undefined)){
      this.uniValidation = false;
    }else {
      this.uniValidation = true;
    }
    if(this.user_id != null ){
      if (this.edu_form.valid==false || this.uniValidation == false){
        this.edu_form.controls.collegeNameCtrl.markAsDirty();
        // this.edu_form.controls.collegeAddressCtrl.markAsDirty();
        this.edu_form.controls.courseNameCtrl.markAsDirty();
        //this.edu_form.controls.overAllGradeCtrl.markAsDirty();
        this.edu_form.controls.rollNoCtrl.markAsDirty();
        this.edu_form.controls.collegePatternCtrl.markAsDirty();
        // this.edu_form.controls.otherUniversityCtrl.markAsDirty();
        // this.edu_form.controls.otherCollegeCtrl.markAsDirty();
        // this.edu_form.controls.otherCourseCtrl.markAsDirty();
  
        if(this.edu_form.controls.courseNameCtrl.value === null || this.edu_form.controls.courseNameCtrl.value ==='' || this.edu_form.controls.courseNameCtrl.value ===undefined){
          this.courseValidation = false;
        }else {
          this.courseValidation = true;
        }
        if((this.edu_form.controls.collegeYearPatternCtrl.value === null || this.edu_form.controls.collegeYearPatternCtrl.value ==='' || this.edu_form.controls.collegeYearPatternCtrl.value ===undefined) && (this.edu_form.controls.collegeSemPatternCtrl.value === null || this.edu_form.controls.collegeSemPatternCtrl.value === '' || this.edu_form.controls.collegeSemPatternCtrl.value === undefined)){
          this.collegeYearValidation = false;
        }else {
          this.collegeYearValidation = true;
        }
  

        if(this.edu_form.controls.monthYearCtrl.value === null || this.edu_form.controls.monthYearCtrl.value ==='' || this.edu_form.controls.monthYearCtrl.value ===undefined){
          this.monthYearValidation = false;
        }else {
          this.monthYearValidation = true;
        }
  
        // if(this.edu_form.controls.monthCtrl.value === null || this.edu_form.controls.monthCtrl.value ==='' || this.edu_form.controls.monthCtrl.value ===undefined){
        //   this.monthValidation = false;
        // }else {
        //   this.monthValidation = true;
        // }
  
        if(this.pattern === null || this.pattern ==='' || this.pattern === undefined ){
          this.ptternValidation = false;
        }else {
          this.ptternValidation = true;
        }

        if(this.edu_form.controls.rollNoCtrl.invalid && (this.edu_form.controls.rollNoCtrl.dirty || this.edu_form.controls.rollNoCtrl.touched)){
          this.rollNOValidation = false;
        }else{
          this.rollNOValidation = true;
        }

        // if(){

        // }
  
      }else{
        var edu_data ={
          collegeName : this.edu_form.controls.collegeNameCtrl.value,
          // collegeAddress : this.edu_form.controls.collegeAddressCtrl.value,
          courseName : this.edu_form.controls.courseNameCtrl.value,
          collegeYear : this.academicYear ? this.academicYear : this.pattern_year,
          semester: this.pattern_semester,
          month : this.edu_form.controls.monthYearCtrl.value,
          //month : this.edu_form.controls.monthCtrl.value,
          //year : this.edu_form.controls.yearCtrl.value,
          rollNo : this.edu_form.controls.rollNoCtrl.value,
          //overAllGrade : this.edu_form.controls.overAllGradeCtrl.value,
          user_id : this.user_id,
          medium_instruction : 'English',
          id : this.edu_id,
          // partname : this.edu_form.controls.partNameCtrl.value,
          otherUniversity : this.edu_form.controls.otherUniversityCtrl.value,
          otherCollege : this.edu_form.controls.otherCollegeCtrl.value,
          otherCourse: this.edu_form.controls.otherCourseCtrl.value,
          pattern : this.pattern,
          result : this.result,
          stillStudying : this.stillStudying,
          duration : this.duration,
          degree_type : this.degree_type,
          course_type : this.course_type,
         college_code : this.college_code,
         prnNumber : this.edu_form.controls.prn_no.value,
         courseId : this.courseId,
         collegeId : this.collegeId,
         specialization :this.edu_form.controls.specialization.value ? this.edu_form.controls.specialization.value : null,
         isAutonomus : this.isAutonomusValue === 'Yes' ? 1 : 0
        }
        
        
        this.api.setEducationalValues(edu_data)
        .subscribe(
          (data: any) => {  
            this.ref.close(data);
            err => console.error(err) 
        });
      }
    }else{
      alert("There is problem in saving data please login with your credentials and add further details.")
    }
  }

  dismiss() {
    this.ref.close();
  }

  selectCollegeBachelor(event, college_code, college){
    this.selectedCollege = event.source.value
    // Autonomous students are now allowed to apply — blocking condition disabled.
    // this.isAutonomus = this.selectedCollege.includes('Autonomus') ? true : false;
    const selectedCollegeEntry = this.collegeData.find(college => college.college_name === this.selectedCollege);
      this.collegeId  = selectedCollegeEntry.id
      
    if (event.isUserInput) { 
      this.myControl.setValidators([ ]);
      this.myControl.updateValueAndValidity();
      this.edu_form.patchValue({
        collegeNameCtrl :college,
      })
      this.college_code = college_code;
    }
  }

  getCourseslist(name){
    this.course_data = [];
    this.api.getCourses()
    .subscribe(
      (data: any) => { 
        if(data['status'] == 200){
          this.course_data = [];
          data['data'].forEach((element)=>{
            this.course_data.push( element ) 
          })
        }else{

        }
    });
  }


  // The course's specialization column may arrive as a JSON array, a JSON string,
  // or a plain string. Normalise all three, dropping blanks and 'Nil'.
  parseSpecialization(value){
    if(value === null || value === undefined || value === ''){
      return [];
    }
    let list: any = value;
    if(typeof list === 'string'){
      try{
        list = JSON.parse(list);
      }catch(e){
        list = [list];
      }
    }
    if(!Array.isArray(list)){
      list = [list];
    }
    return list
      .map(item => (item === null || item === undefined) ? '' : String(item).trim())
      .filter(item => item !== '' && item.toLowerCase() !== 'nil');
  }

  // Show + require Specialization only when the chosen course actually has one.
  applySpecialization(courseEntry){
    this.specializationList = this.parseSpecialization(courseEntry ? courseEntry.specialization : null);
    this.showSpecialization = this.specializationList.length > 0;
    const control = this.edu_form.controls.specialization;
    if(this.showSpecialization){
      control.setValidators([Validators.required]);
      // Re-apply the saved value when editing: the course list arrives after the
      // education record, so the control is still empty on the first pass.
      let value = control.value ? control.value : this.savedSpecialization;
      control.setValue(this.specializationList.indexOf(value) === -1 ? null : value);
    }else{
      // Hidden means this course has no specialization: store NULL, not ''.
      control.setValidators([]);
      control.setValue(null);
    }
    control.updateValueAndValidity();
  }

  syncSpecializationForCourse(courseName){
    // Nothing to resolve against until the course list has loaded. Bailing out here
    // keeps the saved value instead of clearing it on the first pass.
    if(!this.courseData || this.courseData.length === 0){
      return;
    }
    const entry = this.courseData.find(course => course.course_name === courseName);
    this.applySpecialization(entry);
  }

  selectCourse(event, name, part_name){
  // Only act on the option the user actually picked. Switching courses also fires
  // this with isUserInput false for the option being deselected, and acting on that
  // stale event would restore the previous course's id and specialization list.
  if (event.isUserInput) {
    this.selectedcourse = event.source.value;
    const selectedCourseEntry = this.courseData.find(course => course.course_name === this.selectedcourse);
    this.courseId  = selectedCourseEntry ? selectedCourseEntry.id : null;
    this.applySpecialization(selectedCourseEntry);

    this.myControlCourse.setValidators([ ]);
    this.myControlCourse.updateValueAndValidity();
    this.pattern_data_sem = ['Semester I', 'Semester II', 'Semester III', 'Semester IV', 'Semester V', 'Semester VI', 'Semester VII', 'Semester VIII', 'Semester IX', 'Semester X', 'Semester XI', 'Semester XII'];
    this.pattern_data_year = ['First', 'Second', 'Third', 'Fourth', 'Fifth','Sixth'];
    this.duration = part_name;
    var duration_year = this.duration;
    var duratio_sem = 2*this.duration;
    this.pattern_data_year = this.pattern_data_year.splice(0,duration_year);
    this.pattern_data_sem = this.pattern_data_sem.splice(0,duratio_sem);
    this.edu_form.patchValue({
      courseNameCtrl : name,
    })
  }
}

  public findInvalidControls(controls) {
    const invalid = [];

    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
  }

  // MatAutocompleteTrigger 
  editCollegeName(){
    this.edu_form.controls.collegeNameCtrl.setValidators([Validators.required]);
    this.edu_form.controls.collegeNameCtrl.updateValueAndValidity();
    this.collegenameshow = false;
    this.edu_form.patchValue({
      collegeNameCtrl :'',
    })
  }

  editCourseName(){
    this.course_data = [];
    this.coursenameshow = false;
    this.api.getCourses()
    .subscribe(
      (data: any) => { 
        if(data['status'] == 200){
          this.course_data = [];
          data['data'].forEach((element)=>{
            this.course_data.push( element ) 
          })
        }else{

        }
    });
  }


  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());console.log("ctrlValue",ctrlValue);
    
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    // this.yearValid = false;
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.edu_form.patchValue({
      monthYearCtrl :this.date.value,
    })
  }

  onFocus(value){
    this.autoComplete['_results'][value]._onChange('');
    this.autoComplete['_results'][value].openPanel();
    }

    OnlyNoCharAllowed(event): boolean {
      const charCode = event.which ? event.which : event.keyCode;
      if (!(charCode ==32) &&
      !(charCode >47 && charCode  < 58 )  &&
      !(charCode >64 && charCode < 91)&&
      !(charCode >96 && charCode < 123)){
        event.preventDefault()
        return false;
      }
      return true;
      }

      getData(pattern){
        this.pattern = pattern.source.value;
        if(pattern.value == 'semester'){
          this.edu_form.controls.collegeSemPatternCtrl.setValidators([Validators.required]);
          this.edu_form.controls.collegeSemPatternCtrl.updateValueAndValidity();
          this.edu_form.controls.collegeYearPatternCtrl.clearValidators();
          this.edu_form.controls.collegeYearPatternCtrl.updateValueAndValidity();
          this.pattern_annual = true;
        }else if(pattern.value == 'annual'){  
          this.edu_form.controls.collegeSemPatternCtrl.clearValidators(); 
          this.edu_form.controls.collegeSemPatternCtrl.updateValueAndValidity();     
          this.edu_form.controls.collegeYearPatternCtrl.setValidators([Validators.required]);
          this.edu_form.controls.collegeYearPatternCtrl.updateValueAndValidity();
          this.pattern_annual = false;
          this.pattern_semester = null;
        }
        
      }

      onSelectPattern_sem(pattern_sem){
        this.pattern_semester = pattern_sem.value;
        if(this.pattern_semester == 'Semester I' || this.pattern_semester == 'Semester II' ){
          this.academicYear = 'First';
        }else if(this.pattern_semester == 'Semester III' || this.pattern_semester == 'Semester IV'){
          this.academicYear = 'Second';
        }else if(this.pattern_semester == 'Semester V' || this.pattern_semester == 'Semester VI'){
          this.academicYear = 'Third';
        }else if(this.pattern_semester == 'Semester VII' || this.pattern_semester == 'Semester VIII'){
          this.academicYear = 'Fourth';
        }else if(this.pattern_semester == 'Semester IX' || this.pattern_semester == 'Semester X'){
          this.academicYear = 'Fifth';
        }else if(this.pattern_semester == 'Semester XI' || this.pattern_semester == 'Semester XII'){
          this.academicYear = 'Sixth';
        };
      }

      onSelectPattern_year(year){
        this.pattern_year = year.value;
      }

      getResult(result){
        this.result = result.value;
      }

      getIsAutonomus(event){
        this.isAutonomusValue = event.value;
        // Whenever the autonomous choice changes, always reset the college selection
        // (whether one was already selected or not) and re-apply the filtered list.
        this.collegenameshow = false;
        this.college_code = null;
        this.collegeId = null;
        this.selectedCollege = '';
        this.myControl.setValidators([Validators.required]);
        this.myControl.setValue('');
        this.myControl.updateValueAndValidity();
        this.edu_form.controls.collegeNameCtrl.setValidators([Validators.required]);
        this.edu_form.patchValue({
          collegeNameCtrl : '',
        })
        this.edu_form.controls.collegeNameCtrl.updateValueAndValidity();
      }

      getCourse_type(event){
        
        
        this.course_type = event.value;
        if(this.course_type == "External"){
          this.courseExternzl = true;
          this.collegenameshow = true;
          this.edu_form.patchValue({
            collegeNameCtrl :'External Candidates',
          })
        }else{
          this.collegenameshow = false;
          this.courseExternzl = false;
        }
      }

      onPassingYear(event: any) {
        const monthYearCtrl = this.edu_form.controls.monthYearCtrl.value != '' ? moment(this.edu_form.controls.monthYearCtrl.value) : moment(event);
        const year = monthYearCtrl.year();
        // const monthYearCtrl = moment(this.edu_form.controls.monthYearCtrl.value);
        // const year = monthYearCtrl.year();
        console.log('yearyearyearyearyearyearyearyearyearyear',year);
        
        if (year >= 2004 && year <= 2019) {
          this.yearValid = true;
          this.showPopup = true; // Show the popup
        } else {
          this.yearValid = false;
          this.showPopup = false;
        }
      }
      
      onConfirm() {
        this.router.navigate(['/pages/dashboard']);
        this.showPopup = false;
        this.ref.close();
      }
      
}
